export default __webpack_public_path__ + "static/media/guitar_dark.46997f04.jpg";